module.exports = __webpack_public_path__ + "static/media/light.c0270382.jpg";